var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IpsBaseWebService, ActiveProfileService } from "imagine-ui-ng-core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
var AlertAssignmentService = /** @class */ (function (_super) {
    __extends(AlertAssignmentService, _super);
    function AlertAssignmentService(http, activeProfileService) {
        var _this = _super.call(this, http, environment, activeProfileService) || this;
        _this.activeProfileService = activeProfileService;
        _this.init("AlertAssignment", "Shop", "v1");
        return _this;
    }
    AlertAssignmentService.prototype.getAlerts = function () {
        return this.getByRoute(this.urlApiBaseProductPlusVersion + "Alert");
    };
    AlertAssignmentService.prototype.saveAlertAssignments = function (assignments) {
        return this.put(assignments, undefined, this.urlApiBaseProductPlusVersion + "AlertAssignments");
    };
    return AlertAssignmentService;
}(IpsBaseWebService));
export { AlertAssignmentService };
